import {
  MOTOR_COVER_TYPE_RESET_FIELDS,
  MOTOR_HAS_AGENT_RESET_FIELDS,
  MOTOR_YOUNG_DRIVERS_RESET_FIELDS,
  MOTOR_PREMIUM_INPUT_RESET_FIELD_NAMES,
  MOTOR_BENEFIT_RESET_FIELDS_BY_NAME,
} from '../components/ggilComponents/motorResetFields';

export const getSlugIndex = myComponent => {
  return Object.keys(myComponent).findIndex(componentKey =>
    componentKey?.includes('_slug'),
  );
};

export const formatForm = form => {
  if (!form) return;
  const { components } = form;
  if (components) {
    const newComponents = components?.map(component => {
      let tempSlug = null;
      if (component?.AccordionChoice_slug === 'SummaryPanel') {
        tempSlug = component?.AccordionChoice_slug;
        component.AccordionChoice_slug = 'AccordionChoice';
        // console.log('component: ', component);
      }

      const slugIndex = getSlugIndex(component);
      if (slugIndex > -1) {
        // console.log('slugIndex: ', slugIndex);
        const slugValue = Object.values(component)[slugIndex];
        const newComponent = {};
        /* this code below is temporary */

        const result = Object.keys(component).map(oldKey => {
          const removeValue = `${slugValue}_`;
          // console.log('slugValue: ', slugValue);
          // console.log('removeValue: ', removeValue);
          if (oldKey.includes(removeValue)) {
            const newKey = oldKey.substring(removeValue.length);
            newComponent[newKey] = component[oldKey];
          } else {
            newComponent[oldKey] = component[oldKey];
          }
          return oldKey;
        });

        // Motor TT: inject frontend-resident resetFields so the optional benefits /
        // agent fields clear on plan / hasAgent change. Done here (not in Strapi or
        // the reducer) so it re-applies on every render and survives a stale cached
        // wizard config. The components consume resetFields via resetWizardFieldsOnChange.
        if (newComponent.slug === 'MotorExpansionPanelChoice') {
          newComponent.resetOnChange = true;
          newComponent.resetFields = MOTOR_COVER_TYPE_RESET_FIELDS;
        }
        if (newComponent.name === 'hasAgent') {
          newComponent.resetOnChange = true;
          newComponent.resetFields = MOTOR_HAS_AGENT_RESET_FIELDS;
        }
        if (newComponent.name === 'youngDrivers') {
          newComponent.resetOnChange = true;
          newComponent.resetFields = MOTOR_YOUNG_DRIVERS_RESET_FIELDS;
        }
        // Step 2 rating inputs: changing any after a plan + optional benefits were
        // selected must clear the benefits, same as a plan change. Without this only
        // the EV Battery benefit reset itself; the rest stayed checked. Some of these
        // fields (e.g. vehicleCoverageType) already define their own resetFields in
        // config, so MERGE the benefit resets in rather than overwriting — dedup by
        // name, keeping any existing entry (and its staticValue) first.
        if (MOTOR_PREMIUM_INPUT_RESET_FIELD_NAMES.includes(newComponent.name)) {
          newComponent.resetOnChange = true;
          const existingResetFields = Array.isArray(newComponent.resetFields)
            ? newComponent.resetFields
            : [];
          const existingNames = new Set(existingResetFields.map(field => field?.name));
          newComponent.resetFields = [
            ...existingResetFields,
            ...MOTOR_COVER_TYPE_RESET_FIELDS.filter(
              field => !existingNames.has(field?.name),
            ),
          ];
        }
        // Optional benefit checkboxes (e.g. hospitalizationBenefit, survivorsBenefit):
        // unchecking one must clear its OWN sub-form so stale answers (Personal
        // Physician Name/Address, beneficiary details, declarations) don't persist.
        // Merge into any config-defined resetFields, dedup by name.
        if (MOTOR_BENEFIT_RESET_FIELDS_BY_NAME[newComponent.name]) {
          newComponent.resetOnChange = true;
          const existingResetFields = Array.isArray(newComponent.resetFields)
            ? newComponent.resetFields
            : [];
          const existingNames = new Set(existingResetFields.map(field => field?.name));
          newComponent.resetFields = [
            ...existingResetFields,
            ...MOTOR_BENEFIT_RESET_FIELDS_BY_NAME[newComponent.name].filter(
              field => !existingNames.has(field?.name),
            ),
          ];
        }

        if (
          newComponent &&
          (newComponent.slug === 'AccordionChoice' ||
            newComponent.slug === 'MotorExpansionPanelChoice' ||
            newComponent.slug === 'CustomObject' ||
            newComponent.slug === 'UploadModalButton')
        ) {
          const { subForm, customForm, modalForm, items } = newComponent;
          if (subForm) {
            formatForm(subForm?.form);
          }
          if (customForm) {
            formatForm(customForm);
          }
          if (modalForm) {
            formatForm(modalForm?.form);
          }
          if (items && items.length > 0) {
            items.forEach(item => {
              if (item?.optionSubForm) {
                formatForm(item?.optionSubForm);
              }
            });
          }
        }

        if (tempSlug) {
          newComponent.slug = tempSlug;
        }

        return newComponent;
      }
      return component;
    });
    form.components = newComponents;
    // console.log('newComponents: ', newComponents);
    // wizard.forms[index].form.components = newComponents;
  }
};

export const formatWizardData = wizard => {
  // console.log('start wizard: ', wizard);
  if (wizard) {
    const { forms: formWrappers } = wizard || {};

    formWrappers?.forEach((formWrapper, index) => {
      const { form } = formWrapper || {};
      if (form) {
        formatForm(form);
      }
    });
  }
  // console.log('end wizard: ', wizard);
  return wizard;
};
